const REDIRECT_URL_CHARACTERS_TO_ALLOW = /[^a-zA-Z0-9\-_/]/;

export default function sanitizeRedirectUrl(url) {
  if (url.indexOf('/') !== 0) {
    throw new Error(`Path must start with a slash: ${url}`);
  }

  return url.replace(REDIRECT_URL_CHARACTERS_TO_ALLOW, '');
}
